<template>
	<v-btn :color="color" :small="small" :flat="flat" :icon="icon" :disabled="loading" :loading="loading" @click="exportCSVFile"><slot></slot></v-btn>
</template>

<script>
	import * as config from '@/config'

	export default {
		props: {
			color: {	
				type: String,
				default: 'primary'
			},
			small: {
				type: Boolean,
				default: false
			},
			icon: {
				type: Boolean,
				default: false
			},
			flat: {
				type: Boolean,
				default: false
			},
			giveawayBoxId: {
				type: [Number,String],
				default: 0
			}, 
			fileTitle: {
				type: String,
				default: 'file'
			}
		},
		data() {
			return {
				items: [],
				loading: false
			}
		},
	    computed: {
	    	apiUrl() {
	    		return config.BASE_URL + '/giveawayBox/' + this.giveawayBoxId + '/candidates/csv'
	    	},
	    	exportFileName() {
	    		var title = this.fileTitle
				var illegalRe = /[\/\?<>\\:\*\|":]/g;
				var controlRe = /[\x00-\x1f\x80-\x9f]/g;
				var reservedRe = /^\.+$/;
				var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;

				title = title
				    .replace(illegalRe, '')
				    .replace(controlRe, '')
				    .replace(reservedRe, '')
				    .replace(windowsReservedRe, '');

	    		return title;
	    	}
	    },
		methods: {
			convertToCSV(objArray) {
			    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
			    var str = '';

			    for (var i = 0; i < array.length; i++) {
			        var line = '';
			        for (var index in array[i]) {
			            if (line != '') line += ','

			            line += '"' + array[i][index] + '"';
			        }

			        str += line + '\r\n';
			    }

			    return str;
			},
			exportCSVFile() {
				this.loading = true
				axios.get(this.apiUrl)
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]))
						const link = document.createElement('a')

						var exportedFilename = this.exportFileName + '.csv' || 'export.csv'
						
						link.href = url
						link.setAttribute('download', exportedFilename)
						document.body.appendChild(link)
						link.click()

	  					this.loading = false
					})
					.catch((error) => {
						this.loading = false
						console.log(error)
					})
			}			
		}
	}
</script>

<style>
	
</style>